import { create } from 'zustand'

type PromptInputState = {
  promptInput: string
  setPromptInput: (promptInput: string) => void
  clearPromptInput: VoidFunction
}

const initialState: Pick<PromptInputState, 'promptInput'> = {
  promptInput: '',
}

const usePromptInput = create<PromptInputState>(set => ({
  ...initialState,
  clearPromptInput: () => set(initialState),
  setPromptInput: promptInput => set({ promptInput }),
}))

export const useClearPromptInput = () =>
  usePromptInput(state => state.clearPromptInput)
